import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/yaworks.webp';
import screenshot_target from '../../../images/letterfunnel/maartenvervoorn.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Maarten Vervoorn"
      firstname="Maarten"
      companyname="YaWorks"
      competition="Schuberg Philis en InSpark"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/maartenvervoorn.js